import { SCENE_EVENTS } from "../../MVC/Model";
import { makeId, randomIntFromInterval } from "../../MVC/dataHelpers";
import { EMOTION_EVENTS, icons } from "./EmotionEvents";

import { gsap, Linear } from 'gsap';
import { ICON } from "../../Icons/Icons";

export default class TourShowEmoticonButton {
  static get supportedEmojis() {
    return [
      '👌','🤯','👏','🔥',
      '🎉','😍','😂','😮',
    ];
  }

  static #buttonTemplate() {
    return `
<div class="world-bottom-nav__area__item tour-mode__controls__emoji">
  ${ICON.EMOJI}
</div>    
`
  }

  static #menuTemplate() {
    const emojis = this.supportedEmojis.reduce((stack, emoji, index) => {
      const groupIndex = Math.floor(index / 4);
      stack[groupIndex] = [...(stack[groupIndex] ?? []), emoji];
      return stack;
    }, [])

    return `
<div class="tour-mode__top-area">
  <div class="tour-mode__emoji-menu" style="display: none;">
    ${emojis.map((emojiGroup) => `
      <ul class="tour-mode__emoji-menu__list">
        ${emojiGroup.map((emoji) => `
          <li class="tour-mode__emoji-menu__list__item" data-emoji="${emoji}">
            ${emoji}
          </li>
        `).join('')}
      </ul>
    `).join('')}
  </div>
</div>    
`
  }

  static template() {
    return `
<div class="is-flex is-relative">
  ${this.#buttonTemplate()}
  ${this.#menuTemplate()}
</div>    
`
  }

  /**
   * @param {Object<{
   *   userName: string,
   *   id: string,
   *   icon: string,
   *   counter: number,
   * }>}props
   * @return {string}
   */
  receivedEmojiTemplate(props) {
    const hasClass = props.counter % 2 === 0 ? "not-right" : "";
    return `
<div class="animation-holder ${hasClass}" id="${props.id}">
  <div class="animation-wrapper">
    <div class="animation-icon">
      <span>${props.icon}</span>
    </div>
    <div class="animation-text">
      <span>${props.userName}</span>
    </div>
  </div>
</div>
`
  }

  constructor({ model, socket }) {
    this.model = model;
    this.socket = socket;

    this.counter = 0;

    this.$menu = $('.tour-mode__emoji-menu');
    this.$controlBtn = $('.tour-mode__controls__emoji');
    this.$emojiBtns = $('.tour-mode__emoji-menu__list__item');

    this.init()
  }

  init() {
    this.setEventListeners()
  }

  setEventListeners() {
    this.$controlBtn.on('click', () => {
      this.toggle()
    })

    // Hide the menu when click outside the menu
    $(document).on('click', (event) => {
      const $target = $(event.target);
      if(
          this.$menu.is(":visible")
          && !$target.closest('.tour-mode__emoji-menu').length
          && !$target.closest('.tour-mode__controls__emoji').length
      ) {
        this.hide()
      }
    });

    this.$emojiBtns.on('click', (e) => {
      const emoji = $(e.target).data('emoji');

      this.socket.socketTour.sendEmotion(emoji);
    })

    const animate = this.#animate.bind(this)

    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, (e) => {
      this.hide();
      this.model.addEventListener(EMOTION_EVENTS.SHOW_AND_ANIMATE, animate);
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, (e) => {
      this.hide();
      this.model.addEventListener(EMOTION_EVENTS.SHOW_AND_ANIMATE, animate);
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      this.hide();
      this.model.removeEventListener(EMOTION_EVENTS.SHOW_AND_ANIMATE, animate);
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_STOP, (e) => {
      this.hide();
      this.model.removeEventListener(EMOTION_EVENTS.SHOW_AND_ANIMATE, animate);
    });
  }

  show() {
    this.$menu.show()
  }
  hide() {
    this.$menu.hide()
  }

  toggle() {
    this.$menu.toggle()
  }

  #animate(e) {
    const data = e.data || e.payload;
    const { userName, userAvatarUrl, icon } = data;
    if (!icon || TourShowEmoticonButton.supportedEmojis.indexOf(icon) === -1) {
      return;
    }

    this.counter++;

    let startTime = null;
    const amplitude = 20;
    const _duration = randomIntFromInterval(3, 5) + Math.random();

    let anim = $(this.receivedEmojiTemplate(
        {
          userName,
          id: makeId(3),
          icon,
          userAvatarUrl,
          counter: this.counter,
        }
    ));

    const initialX = randomIntFromInterval(-50, 50);
    gsap.set(anim, { x: initialX, opacity: 0 });
    $(document.body).append(anim);

    const image = anim.find(".animation-image");

    gsap.to(image, {
      duration: _duration,
      ease: Linear.easeOut,
      opacity: 0,
      scale: 0,
    });

    gsap.to(anim, {
      duration: _duration,
      ease: Linear.easeOut,
      y: -500 + Math.random() * 50,
      opacity: 3, //because on 1/3 will opacity be 1

      onUpdate: () => {
        if (startTime === null) {
          startTime = performance.now();
        }
        const currentTime = (performance.now() - startTime) / 1000;
        const x = amplitude * Math.sin(currentTime * 2 * Math.PI / _duration);
        gsap.set(anim, { x: x });
      },
      yoyo: false, // The animation will not reverse directions
      onComplete: () => {
        gsap.killTweensOf(anim);
        anim.remove();
        anim = null;
      }
    });
  }
}
